import { Routes } from '@angular/router';

import { Tabs } from './shared/tabs.enum';

import { ProfileComponent } from './profile/profile.component';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { LoginComponent } from './authentication/login.component';
import { LogoutComponent } from './authentication/logout.component';
import { LoggedInComponent } from './authentication/logged-in.component';
import { StaffGuard } from './authentication/staff.guard';
import { AdminGuard } from './authentication/admin.guard';
import { SignupComponent } from './authentication/signup.component';
import { InternalAdminGuard } from './authentication/internal-admin.guard';
import { AccountTabAdminGuard } from './authentication/account-tab-admin.guard';
import { InternalAdminOrAccountAdminOrSupportEngineerOrEnrollmentSupportGuard } from '@app/authentication/internal-admin-or-account-admin-or-support-engineer-or-enrollment-support-guard.service';

export const routes: Routes = [
  {
    path: 'accounts',
    loadChildren: () => import('./accounts/accounts.routes').then((m) => m.accountsRoutes),
    data: {
      tab: Tabs.ACCOUNTS,
    },
    canLoad: [AuthenticationGuard, AccountTabAdminGuard],
    canActivate: [AuthenticationGuard, AccountTabAdminGuard],
  },
  {
    path: 'activities',
    loadChildren: () => import('./activities/activities.routes').then((m) => m.activitiesRoutes),
    data: {
      tab: Tabs.ACTIVITIES,
    },
    canLoad: [AuthenticationGuard],
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'admin-home',
    loadChildren: () => import('./admin-home/admin-home.routes').then((m) => m.adminHomeRoutes),
    data: {
      tab: Tabs.ADMIN_HOME,
    },
    canLoad: [AuthenticationGuard, AdminGuard],
    canActivate: [AuthenticationGuard, AdminGuard],
  },
  {
    path: 'component-library',
    loadChildren: () =>
      import('./shared/component-library/component-library.routes').then(
        (m) => m.componentLibraryRoutes,
      ),
    data: {
      tab: Tabs.LOGIN,
    },
  },
  {
    path: 'configuration',
    loadChildren: () =>
      import('./configuration-management/configuration-management.routes').then(
        (m) => m.configurationManagementRoutes,
      ),
    data: {
      tab: Tabs.CONFIGURATION,
    },
    canLoad: [AuthenticationGuard, InternalAdminGuard],
    canActivate: [AuthenticationGuard, InternalAdminGuard],
  },
  {
    path: 'goals',
    loadChildren: () => import('./goals/goals.routes').then((m) => m.goalsRoutes),
    data: {
      tab: Tabs.GOALS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'assessments',
    loadChildren: () => import('./assessments/assessments.routes').then((m) => m.assessmentsRoutes),
    data: {
      tab: Tabs.ASSESSMENTS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'families',
    loadChildren: () => import('./families/families.routes').then((m) => m.familiesRoutes),
    data: {
      tab: Tabs.FAMILIES,
    },
    canLoad: [
      AuthenticationGuard,
      InternalAdminOrAccountAdminOrSupportEngineerOrEnrollmentSupportGuard,
    ],
    canActivate: [
      AuthenticationGuard,
      InternalAdminOrAccountAdminOrSupportEngineerOrEnrollmentSupportGuard,
    ],
  },
  {
    path: 'logged-in',
    component: LoggedInComponent,
    data: {
      tab: Tabs.LOGIN,
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      tab: Tabs.LOGIN,
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      tab: Tabs.LOGIN,
    },
  },
  {
    path: 'signup',
    component: SignupComponent,
    data: {
      tab: Tabs.LOGIN,
    },
  },
  {
    path: 'messages-and-notifications',
    loadChildren: () =>
      import('./messages-and-notifications/messages-and-notifications.routes').then(
        (m) => m.messagesAndNotificationsRoutes,
      ),
    data: {
      tab: Tabs.MESSAGES_AND_NOTIFICATIONS,
    },
    canLoad: [AuthenticationGuard],
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'organizations',
    loadChildren: () =>
      import('./organizations/organizations.routes').then((m) => m.organizationsRoutes),
    data: {
      tab: Tabs.ORGANIZATIONS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    data: {
      tab: Tabs.PROFILE,
    },
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.routes').then((m) => m.reportsRoutes),
    data: {
      tab: Tabs.REPORTS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'teacher-dashboards',
    loadChildren: () =>
      import('./teacher-dashboards/teacher-dashboards.routes').then(
        (m) => m.teacherDashboardsRoutes,
      ),
    data: {
      tab: Tabs.TEACHER_DASHBOARDS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'teacher-home',
    loadChildren: () =>
      import('./teacher-home/teacher-home.routes').then((m) => m.teacherHomeRoutes),
    data: {
      tab: Tabs.TEACHER_HOME,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'teacher-users',
    loadChildren: () =>
      import('./teacher-users/teacher-users.routes').then((m) => m.teacherUsersRoutes),
    data: {
      tab: Tabs.TEACHER_USERS,
    },
    canLoad: [AuthenticationGuard, StaffGuard],
    canActivate: [AuthenticationGuard, StaffGuard],
  },
  {
    path: 'notifications-manager',
    loadChildren: () =>
      import('./notifications-manager/notifications-manager.routes').then(
        (m) => m.notificationsManagerRoutes,
      ),
    data: {
      tab: Tabs.NOTIFICATIONS_MANAGER,
    },
    canLoad: [AuthenticationGuard, AdminGuard],
    canActivate: [AuthenticationGuard, AdminGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
